import React, { type CSSProperties } from 'react';

import { cn } from '../../lib/utils';
import { friendlyOp } from 'loot-core/src/shared/rules';

import { Button } from '../ui/button2';

type OpButtonProps = {
  op: string;
  isSelected: boolean;
  onClick: () => void;
  style?: CSSProperties;
};

export function OpButton({ op, isSelected, style, onClick }: OpButtonProps) {
  return (
    <Button
      variant="bare"
      style={style}
      className={cn(
        'bg-[var(--color-pillBackground)] mb-[5px]',
        isSelected &&
          'bg-[var(--color-buttonNormalSelectedBackground)] text-[var(--color-buttonNormalSelectedText)] hover:bg-[var(--color-buttonNormalSelectedBackground)] hover:text-[var(--color-buttonNormalSelectedText)] active:bg-[var(--color-buttonNormalSelectedBackground)] active:text-[var(--color-buttonNormalSelectedText)]',
      )}
      onClick={onClick}
    >
      {friendlyOp(op)}
    </Button>
  );
}
